const requireModule = require.context('.', false, /\.vue$/) //extract vue files inside modules folder

const components = {}

requireModule.keys().forEach(fileName => {
    const componentName = fileName.replace(/(\.\/|\.vue)/g, '')
    components[componentName] = requireModule(fileName).default
})

export default components
